import "externalized-styles-chunk.css";
// extracted by mini-css-extract-plugin
export default {"icon_wrapper":"icon_wrapper_2b587dcd","icon_unit":"icon_unit_2b587dcd","icon_block":"icon_block_2b587dcd","icon_with-loader":"icon_with-loader_2b587dcd"};